// extracted by mini-css-extract-plugin
export default {"header":"Main_header__2mPu-","body":"Main_body__ozAX4"};